export default __webpack_public_path__ + "static/media/user_logo.042fe55b.jpeg";